import * as types from '../actions/actionTypes';
import initialState from './initialState';
import _ from 'lodash';

export default (state = initialState.supplierCompetencies, action) => {

    let updatedSelection;

    switch (action.type) {

        case types.CHANGE_MULTISTEP_SELECT_QUERY :
            return {
                ...state,
                ...{query: action.query}
            };

        case types.GET_SUPPLIER_COMPETENCIES_SUCCESS :
            return {
                ...state,
                ...{competencies: action.competencies}
            };

        case types.GET_SELECTED_COMPETENCIES_SUCCESS :

            return {
                ...state,
                ...{selected: action.competencies.map(item => item.id)}
            };

        case types.SELECT_MULTISTEP_ITEM :
            return {
                ...state,
                ...{selectedOne: action.itemId}
            };

        case types.DESELECT_MULTISTEP_ITEM :
            return {
                ...state,
                ...{selectedOne: undefined}
            };

        case types.ADD_MULTISTEP_ITEM :

            updatedSelection = _.uniq([...state.selected, ...[action.itemId]]);

            return {
                ...state,
                ...{selected: updatedSelection}
            };

        case types.DELETE_MULTISTEP_ITEM :

            updatedSelection = state.selected
                .filter(id => id !== action.itemId);

            return {
                ...state,
                ...{selected: updatedSelection}
            };

        default :
            return state;
    }

};


// WEBPACK FOOTER //
// ./web/src/reducers/supplierCompetenciesReducer.js